import { render } from "./InstitutionTypeSelector.vue?vue&type=template&id=4e39d070"
import script from "./InstitutionTypeSelector.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__